import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase';

Vue.config.productionTip = false;

Vue.use(firestorePlugin);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
